let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("b52u5"), load("3Eu7W"), load("3TNOq"), load("eCgOQ"), load("ipTFT"), load("2YlyO")]).then(() => parcelRequire('753aK'));